export const TIME_OPTIONS: { value: string; label: string }[] = (() => {
  const options: { value: string; label: string }[] = []
  for (let h = 6; h <= 22; h++) {
    for (const m of [0, 30]) {
      const value = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
      const period = h < 12 ? 'AM' : 'PM'
      const displayH = h === 0 ? 12 : h <= 12 ? h : h - 12
      options.push({ value, label: `${displayH}:${String(m).padStart(2, '0')} ${period}` })
    }
  }
  return options
})()

export function formatTime12h(time: string): string {
  const [h, m] = time.split(':').map(Number)
  const period = h < 12 ? 'AM' : 'PM'
  const displayH = h === 0 ? 12 : h <= 12 ? h : h - 12
  return `${displayH}:${String(m).padStart(2, '0')} ${period}`
}

export function parseLocalDate(value: string): Date {
  const [y, mo, d] = value.split('-').map(Number)
  return new Date(y, mo - 1, d)
}

export function toISODate(date: Date): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

export function addDays(date: Date, days: number): Date {
  const result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

export function formatDisplayDate(dateStr: string, opts?: Intl.DateTimeFormatOptions): string {
  const [y, m, d] = dateStr.split('-').map(Number)
  return new Date(y, m - 1, d).toLocaleDateString('es-MX', opts ?? {
    weekday: 'short', day: 'numeric', month: 'short',
  })
}
